/* eslint-disable consistent-return */
type Sentry = typeof import("@sentry/react")
let ready: Promise<Sentry> | null = null

export const Tracing = new Proxy<Record<string, any>>(
  {},
  {
    get(_, prop: string) {
      // Special‑case the init() call
      if (prop === "init") {
        return (config: Parameters<Sentry["init"]>[0]) => {
          if (!ready) {
            ready = import("@sentry/react").then((mod) => {
              const mp = mod
              mp.init(config)
              return mp
            })
          }
          return ready
        }
      }

      // For any other property/method
      return (...args: any[]) => {
        if (!ready) {
          console.warn(`Sentry not initialised—dropping call to [${prop}]`, ...args)
          return
        }
        return ready.then((mp) => {
          const fn = (mp as any)[prop]
          if (typeof fn === "function") {
            return fn.apply(mp, args)
          }
          return fn
        })
      }
    },
  }
) as Sentry & { init: (config?: any) => Promise<Sentry> }
export default Tracing

export const { captureException, setUser } = Tracing
